import React from "react";

import { Table } from "antd";

import { isEmpty } from "lodash";

const dataKeys = [
  "Power Source",
  "Positioners",
  "Wire Feeder MPN",
  "Spool or Drum Wire Dispensing",
];

function RobotDetail(props) {
  const {
    robot: { swr_information = [], hubspot_information = {} },
  } = props;

  const columns = [
    { title: "Type", dataIndex: "name", key: "name", width: "50%" },
    { title: "Model / Name", dataIndex: "value", key: "value", width: "25%" },
    { title: "Note", dataIndex: "comment", key: "comment", width: "25%" },
  ];

  if (isEmpty(hubspot_information)) {
    const dataSource = swr_information.filter((item) =>
      dataKeys.includes(item.name)
    );
    const pagination = { hideOnSinglePage: true, pageSize: dataSource.length };
    return (
      <Table
        className="SWRDetailList_Table"
        // style={{ height: 333 }}
        columns={columns}
        scroll={{ x: "fit-content", y: 300 }}
        expandable={{
          rowExpandable: (record) => !!record.children,
        }}
        dataSource={dataSource}
        pagination={pagination}
      />
    );
  } else {
    const data = Object.entries(hubspot_information).map(([key, value]) => {
      return { name: key, value: value, key: key, comment: null };
    });

    const dataSource = data
      .map((item) => {
        switch (item.name) {
          case "name_mc":
            return {
              ...item,
              name: "Operator",
              comment: data.find((i) => i.name === "title_mc").value,
              children: [
                {
                  name: "Email",
                  value: data.find((i) => i.name === "email_mc").value,
                  key: "email_mc",
                },
                {
                  name: "Office",
                  value: data.find((i) => i.name === "office_no__mc").value,
                  key: "office_no__mc",
                },
                {
                  name: "Cell",
                  value: data.find((i) => i.name === "cell_no_mc").value,
                  key: "cell_no_mc",
                },
              ],
            };

          case "novcare_tier__gold__silver__bronze_":
            return {
              ...item,
              name: "NovCare",
              value: data.find(
                (i) => i.name === "novcare_tier__gold__silver__bronze_"
              ).value,
              comment:
                data.find((i) => i.name === "novarccare_coverage_start_date")
                  .value +
                data.find((i) => i.name === "novarccare_coverage_end_date")
                  .value
                  ? data.find(
                      (i) => i.name === "novarccare_coverage_start_date"
                    ).value +
                    " ~ " +
                    data.find((i) => i.name === "novarccare_coverage_end_date")
                      .value
                  : null,
            };

          case "positioners":
            return {
              ...item,
              name: "Positioners",
              children: [
                {
                  name: "Positioner Cable Length",
                  value: data.find((i) => i.name === "positioner_cable_length")
                    .value,
                },
                {
                  name: "Positioner Drive Size",
                  value: data.find((i) => i.name === "positioner_drive_size")
                    .value,
                },
                {
                  name: "Positioner E stop",
                  value: data.find((i) => i.name === "positioner_e_stop").value,
                },
              ],
            };

          case "power_source":
            return {
              ...item,
              name: "Power Source",
              comment: data.find((i) => i.name === "power_source_serial_number")
                .value,
            };

          case "spool_or_drum_wire_dispensing":
            return {
              ...item,
              name: "Spool or Drum Wire Dispensing",
            };

          case "wire_feeder_mpn":
            return {
              ...item,
              name: "Wire Feeder MPN",
              comment: data.find((i) => i.name === "wire_feeder_serial_number")
                .value,
            };
          default:
          // return { ...item };
        }
      })
      .filter((item) => item);

    return (
      <Table
        className="SWRDetailList_Table"
        // style={{ height: 333 }}
        columns={columns}
        scroll={{ x: "fit-content", y: 300 }}
        expandable={{
          rowExpandable: (record) => !!record.children,
        }}
        dataSource={dataSource}
        pagination={{ hideOnSinglePage: true, pageSize: dataSource.length }}
      />
    );
  }
}
export default RobotDetail;
